// extracted by mini-css-extract-plugin
module.exports = {"h1tag":"PrivacyPolicy_h1tag__0Jc5L","h2tag":"PrivacyPolicy_h2tag__Jgvq2","ptag":"PrivacyPolicy_ptag__RW5TH","effDate":"PrivacyPolicy_effDate__yzcJP"};